export default function BlogTemplate({ renderSections }) {
  return <div>{renderSections()}</div>;
}

BlogTemplate.displayName = 'BlogTemplate';
